export default __webpack_public_path__ + "static/personal-storage-2fc347b1b6d45f2c64b2a3ee262bef58.jpg";